// extracted by mini-css-extract-plugin
export default {"section":"section---gmXJi","active":"active---hPrmG","marginRight":"marginRight---SFHMK","userPlaceholder":"userPlaceholder---m2Ep0"};